import React, { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import { Map, Button, RotatedImageOverlay } from '@components';
import Control from 'react-leaflet-control';
import DetectedTargetPopup from './DetectedTargetPopup';
import { useTranslation } from '@hooks';
import { HeatMapDispatchContext, HeatMapStateContext } from '../index';
import HeatmapLayer from './HeatmapLayer';
import { setHeatmapPointsLocUpdate } from '../heatMapReducer';

const HeatMap = (props, ref) => {
    const t = useTranslation('RealTimeLocationStatus');
    const state = useContext(HeatMapStateContext);
    const dispatch = useContext(HeatMapDispatchContext);
    const { selectedFloor, play, playTime, resultHeatmapPointsLoc } = state;

    useEffect(() => {
        if (play) {
            dispatch(setHeatmapPointsLocUpdate(playTime));
        }
    }, [playTime, play]);

    const mapRef = useRef();

    const heatMapConfig = {
        radius: 34,
        blur: 40,
        gradient: {
            0.4: 'blue',
            0.6: 'cyan',
            0.7: 'lime',
            0.8: 'yellow',
            1.0: 'red',
        },
    };

    const [togglePopup, setTogglePopup] = useState(false);
    const handleModalToggle = () => {
        setTogglePopup(!togglePopup);
    };

    return (
        <div className={'w-100 h-80'}>
            <Map tile={false} ref={mapRef} zoom={13}>
                <Control position="topleft" className={'control-container'}>
                    <Button iconName="info_outline" onClick={handleModalToggle} className={'leaflet-map-btn btn-icon'}>
                        {t('Detail')}
                    </Button>
                </Control>
                {!!selectedFloor ? (
                    selectedFloor.imgURL && (
                        <RotatedImageOverlay
                            key={selectedFloor.floorId}
                            url={selectedFloor.imgURL}
                            deg={selectedFloor.deg}
                            bounds={selectedFloor.bounds}
                            onLoad={() => {
                                const map = mapRef?.current?.leafletElement;
                                if (map) {
                                    map.fitBounds(selectedFloor.bounds);
                                }
                            }}
                        />
                    )
                ) : (
                    <div
                        style={{
                            color: 'black',
                            fontSize: '1.5rem',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }}
                    >
                        {t('No Floor')}
                    </div>
                )}
                <HeatmapLayer
                    blur={heatMapConfig.blur}
                    radius={heatMapConfig.radius}
                    minOpacity={0.1}
                    gradient={heatMapConfig.gradient}
                    points={resultHeatmapPointsLoc[0]}
                    longitudeExtractor={m => m[1]}
                    latitudeExtractor={m => m[0]}
                    intensityExtractor={m => parseFloat(m[2])}
                />
                <DetectedTargetPopup
                    modal={togglePopup}
                    toggleModal={handleModalToggle}
                    widgetRef={ref}
                    mapRef={mapRef}
                />
            </Map>
        </div>
    );
};

export default forwardRef(HeatMap);
